<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/S3uGGB/tc-custom/9780544935341.jpg?1705549507309" alt="This image is the cover for the book Delta Wedding and The Ponder Heart"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Delta Wedding and The Ponder Heart
      </h1>
      <p class="bookDescription body article font2">
        <b>These two classic novels by the Pulitzer Prize winning author depict 20th century Southern life “</b><b>with infinite finesse” (<i>The Christian Science Monitor</i>).</b><br/>  <br/> Set in 1923, Eudora Welty’s first novel, <i>The Delta Wedding</i>, centers around the Fairchild family and their preparations for a wedding at their Mississippi plantation. Drama leads to drama, and the result is a surprising portrait of a large and clamorous Southern family that is “nothing short of riotous” (<i>The New Yorker</i>).<br/>  <br/> In <i>The Ponder Heart</i>, Daniel Ponder of Clay County, Mississippi, is giving away family heirlooms, a watch, and so far, at least one family business. His niece, Edna Earle, has a solution to save the family fortune from Daniel’s mortifying philanthropy: As much as she loves her Uncle Daniel, she’s decided to have him institutionalized in this “wonderful tragicomedy” (<i>The New York Times</i>).
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Eudora Welty
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?01f1c5c8